import React from 'react';
import { Button } from 'office-ui-fabric-react';
import LoginForm from './common/LoginForm';
import imgCity from './imgs/city.jpg';
import imgLogo from './imgs/login-logo.png';

export default class LoginPage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-u-md8 p0">
                        <img className="vh100 w100p object-fit-cover" src={imgCity} />
                    </div>
                    <div className="ms-Grid-col ms-u-md4 p0">
                        <div className="p20">
                            <div className="p20">
                                <img className="w100p" src={imgLogo} />
                            </div>
                            <LoginForm />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./client/components/Login.js